<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>New Entity Type</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">
                What's the name of the Entity Type?
              </div>
              <v-text-field
                v-model="name"
                hide-details
                dense
                outlined
                placeholder="Pin Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      name: "",
    };
  },
  computed: {
    changeFields() {
      return {
        name: this.name,
      };
    },
  },
  methods: {
    ...mapActions({
      createNewEntityType: "$_home/createNewContent",
      getEntityTypes: "$_home/getContent",
    }),
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    cancel() {
      this.name = "";

      this.dialog = false;
    },
    save() {
      console.log(this.changeFields);
      this.createNewEntityType({
        details: this.changeFields,
        collection: "entityTypes",
        type: "Enitity Type",
      }).then(() => {
        this.cancel();
        this.getEntityTypes({
          collection: "entityTypes",
          mutation: "updateEntityTypes",
        });
      });
    },
  },
};
</script>

<style>
</style>

          